import React from 'react';
import { CenterMessageCard } from 'components/CenterMessageCard';


export const AuthRequired = ( { roleID } ) =>  {
        return (
          <CenterMessageCard 
              icon="fa-hand-paper-o"
              title="Autorización requerida">
                No tenés permisos para acceder a esta sección. En caso que lo requieras
                                solicita al administrador el rol <b>{roleID&&roleID.toString()}</b> 
          </CenterMessageCard> 

        ); 
}



